import styled from 'styled-components';

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows.card};
  transition: all ${({ theme }) => theme.transitions.spring};
  animation: fadeInUp 0.6s ease forwards;
  opacity: 0;
  animation-fill-mode: forwards;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.cardHover};
    transform: translateY(-6px);
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: 220px;
  overflow: hidden;
  position: relative;
  background: ${({ theme }) => theme.colors.secondaryLight};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    height: 240px;
  }
`;

export const CardBadge = styled.span`
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  padding: 0.25rem 0.65rem;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(4px);
  font-size: 0.7rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primaryDark};
  letter-spacing: 0.04em;
  text-transform: uppercase;
  z-index: 1;
`;

export const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform ${({ theme }) => theme.transitions.slow};

  ${Card}:hover & {
    transform: scale(1.05);
  }
`;

export const CardContent = styled.div`
  padding: 1rem 1.25rem 1.25rem;
  display: flex;
  flex-direction: column;
`;

export const ProductName = styled.h3`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 1.1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primaryDark};
  margin-bottom: 0.4rem;
`;

export const ProductDescription = styled.p`
  font-size: 0.84rem;
  color: ${({ theme }) => theme.colors.textMuted};
  line-height: 1.5;
  margin-bottom: 0.85rem;
  min-height: 2.5em;
`;

export const CardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
`;

export const ProductPrice = styled.span`
  font-size: 1.1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primaryDark};
`;

export const AddToCartButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.55rem 1.1rem;
  background: ${({ theme }) => theme.colors.primaryDark};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.spring};
  min-height: 40px;

  &:hover {
    background: ${({ theme }) => theme.colors.dark};
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadows.button};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }

  &:active {
    transform: translateY(0);
  }

  svg { font-size: 0.95rem; }
`;

export const WeightSelector = styled.div`
  display: flex;
  gap: 0.35rem;
  margin-bottom: 0.75rem;
  flex-wrap: wrap;
`;

export const WeightPill = styled.button<{ $active: boolean }>`
  padding: 0.3rem 0.65rem;
  font-size: 0.75rem;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.body};
  border-radius: ${({ theme }) => theme.borderRadius.full};
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.default};
  border: 1.5px solid ${({ $active, theme }) =>
    $active ? theme.colors.primaryDark : theme.colors.secondary};
  background: ${({ $active, theme }) =>
    $active ? theme.colors.primaryDark : 'transparent'};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.white : theme.colors.primaryDark};

  &:hover {
    border-color: ${({ theme }) => theme.colors.primaryDark};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: 2px;
  }
`;

export const QuantityRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  margin-bottom: 0.75rem;
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.full};
  overflow: hidden;
  width: fit-content;
`;

export const QtyBtn = styled.button`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.secondaryLight};
  border: none;
  color: ${({ theme }) => theme.colors.primaryDark};
  font-size: 1rem;
  cursor: pointer;
  transition: background ${({ theme }) => theme.transitions.default};

  &:hover {
    background: ${({ theme }) => theme.colors.secondary};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.primary};
    outline-offset: -2px;
  }
`;

export const QtyVal = styled.span`
  width: 38px;
  text-align: center;
  font-size: 0.88rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primaryDark};
  background: ${({ theme }) => theme.colors.white};
  line-height: 36px;
`;

export const AddedFeedback = styled.span`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 1.1rem;
  background: #25d366;
  color: white;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  font-size: 0.8rem;
  font-weight: 600;
  animation: scaleIn 0.3s ease forwards;

  svg { font-size: 0.95rem; }
`;

